import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { CurrencyState } from "../Context";
import { CoinList } from "../config/api";
import TableRow from "./TableRow";
import { LinearProgress } from "@mui/material";

function Markets() {
  const { currency } = CurrencyState();

  const [coins, setCoins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchCoins = async () => {
      setIsLoading(true);
      const response = await axios.get(CoinList(currency));
      setCoins(response.data);
      setIsLoading(false);
    };

    fetchCoins();
  }, [currency]);

  return (
    <Container>
      <Content>
        <h1>TOP 10 ASSETS</h1>

        {!isLoading ? (
          <table>
            <tbody>
              <tr className="table-header">
                <td>
                  <b>Icon</b>
                </td>
                <td className="name-col">
                  <b>Name</b>
                </td>
                <td>
                  <b>Price</b>
                </td>
                <td>
                  <b>Change</b>
                </td>
                <td>
                  <b>Trade</b>
                </td>
              </tr>
              <>
                {coins.map((coin) => {
                  return (
                    <TableRow
                      key={coin.market_cap_rank}
                      id={coin.id}
                      icon={coin.image}
                      price_change_percentage={coin.price_change_percentage_24h}
                      name={coin.name}
                      current_price={coin.current_price.toFixed(2)}
                    />
                  );
                })}
              </>
            </tbody>
          </table>
        ) : (
          <div>
            <LinearProgress style={{ backgroundColor: "var(--primary)" }} />
          </div>
        )}
      </Content>
    </Container>
  );
}

export default Markets;

const Container = styled.div`
  width: 100%;
  padding: 30px 0;
  background-color: var(--background);
`;

const Content = styled.div`
    justify-content: center;
    align-items: center;

    h1 {
        font-size: 36px;
        text-align: center;
        padding: 20px 0;
    }

    table {
        width: 90%;
        background-color: #fff;
        margin: 0 auto;
        margin-bottom: 50px;
        border-radius: 10px;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

        tr {
            width: 25%;
            text-align: center;
            
            :hover {
                background-color: #f5f8ff;
                transition: 0.3s ease-in;
                box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            }
        }

        .table-header {
            :hover {
                background-color: #fff;
                box-shadow: none;
            }
        }

        td {
            font-weight: bold;
            text-transform: uppercase;
            padding: 20px;

            img {
                width: 50px;
                height: 50px;
            }

            button {
                width: 130px;
                height: 50px;
                text-transform: uppercase;
                border: none;
                border-radius: 20px;
                font-size: 12px;
                background-color: var(--primary);
                color: #fff;
                cursor: pointer;
                font-weight: 700;
                margin-top: 5px;
                

                :hover {
                    background-color: transparent;
                    border: 2px solid var(--primary);
                    color: var(--primary);
                    transition: 0.3s ease-in;
                }
            }

            .sell-btn {
                background: var(--sell-btn);

                :hover {
                    background-color: transparent;
                    border: 2px solid var(--sell-btn);
                    color: var(--sell-btn);
                }
            }
        }

    }

    @media (max-width: 768px) {
        
    h1 {
        font-size: 24px;
    }

    table {
        border-radius: 0px;
        width: 94%;

        tr {
            width: 22%;
            text-align: center;
        }

        td {
            font-weight: 400;
            text-transform: uppercase;
            padding: 10px;
            font-size: 12px;

            img {
                width: 30px;
                height: 30px;
            }

            button {
                width: 60px;
                height: 40px;
                font-size: 11px;
                margin-top: 5px;
                font-weight: 600;
            }
        }
    }

`;
